var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-gallery"},[_c('UiSliderBox',{staticClass:"slider",attrs:{"images":_vm.images,"swiperOption":_vm.swiperOption,"height":50,"width":100,"button":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }